

import {
  FETCH_PARK_ATTENDANCE_REQUEST,
  FETCH_PARK_ATTENDANCE_SUCCESS,
  FETCH_PARK_ATTENDANCE_FAILURE,

  DELETE_PARK_ATTENDANCE_REQUEST,
  DELETE_PARK_ATTENDANCE_SUCCESS,
  DELETE_PARK_ATTENDANCE_FAILURE,

  FETCH_ATTENDANCE_DEFAULTERS_REQUEST,
  FETCH_ATTENDANCE_DEFAULTERS_SUCCESS,
  FETCH_ATTENDANCE_DEFAULTERS_FAILURE,

  FETCH_PROJECT_WISE_DEFAULTERS_REQUEST,
  FETCH_PROJECT_WISE_DEFAULTERS_SUCCESS,
  FETCH_PROJECT_WISE_DEFAULTERS_FAILURE,

  FETCH_PROJECT_ATTENDANCE_REQUEST,
  FETCH_PROJECT_ATTENDANCE_SUCCESS,
  FETCH_PROJECT_ATTENDANCE_FAILURE,

} from "../actions/ParkAttendanceActions";


/* =========================
   INITIAL STATE
========================= */
const initialState = {
  attendance: [],
  defaulters: [],
  projectWiseDefaulters: [],
  projectAttendance: [],        // ✅ NEW
  projectAttendanceSummary: {}, // ✅ NEW

  loading: false,
  error: null,

  pagination: {
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    limit: 10,
  },
};


/* =========================
   REDUCER
========================= */
const parkAttendanceReducer = (state = initialState, action) => {
  switch (action.type) {

    /* =========================
       FETCH PARK ATTENDANCE
    ========================== */
    case FETCH_PARK_ATTENDANCE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PARK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: action.payload.attendance || [],
        pagination: action.payload.pagination || initialState.pagination,
      };

    case FETCH_PARK_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to load attendance",
      };


    /* =========================
       FETCH ATTENDANCE DEFAULTERS
    ========================== */
    case FETCH_ATTENDANCE_DEFAULTERS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ATTENDANCE_DEFAULTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        defaulters: action.payload.defaulters || [],
        pagination: action.payload.pagination || initialState.pagination,
      };

    case FETCH_ATTENDANCE_DEFAULTERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to load defaulters",
      };


    /* =========================
       FETCH PROJECT-WISE DEFAULTERS
    ========================== */
    case FETCH_PROJECT_WISE_DEFAULTERS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PROJECT_WISE_DEFAULTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        projectWiseDefaulters: action.payload.defaulters || [],
        pagination: action.payload.pagination || initialState.pagination,
      };

    case FETCH_PROJECT_WISE_DEFAULTERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to load project-wise defaulters",
      };


    /* =========================
       ✅ FETCH PROJECT ATTENDANCE (NEW API)
    ========================== */
    case FETCH_PROJECT_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PROJECT_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,

        // attendance list
        projectAttendance: action.payload.data || [],

        // summary object
        projectAttendanceSummary: action.payload.summary || {},

        // pagination mapping (API → Redux)
        pagination: {
          totalRecords: action.payload.pagination?.total_records || 0,
          currentPage: action.payload.pagination?.current_page || 1,
          totalPages: action.payload.pagination?.total_pages || 1,
          limit: action.payload.pagination?.per_page || 10,
        },
      };

    case FETCH_PROJECT_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to load project attendance",
      };


    /* =========================
       DELETE PARK ATTENDANCE
    ========================== */
    case DELETE_PARK_ATTENDANCE_REQUEST:
      return { ...state, loading: true };

    case DELETE_PARK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: state.attendance.filter(
          (item) => item.id !== action.payload
        ),
      };

    case DELETE_PARK_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Delete failed",
      };

    default:
      return state;
  }
};

export default parkAttendanceReducer;